import AnalyzeCondition from '@/components/common/Result/AnalyzeCondition/AnalyzeCondition'
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  name: 'BookmarkDialog',
  components: {
    AnalyzeCondition: AnalyzeCondition
  },
  props: {
    showSelectBookmark: {
      type: Boolean,
      default: false
    },
    showAddBookmark: {
      type: Boolean,
      default: false
    },
    showEditBookmark: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: null
    },
    bookmarkPublishSettingFlag: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    editData: {
      memo: '',
      publishSetting: '0',
      name: '',
      conditions: {},
      condition_jp: [],
      historyId: null
    },
    bookmarkList: [],
    mockItems: [
      {
        productNames: [
          '食用油',
          'スープ',
          '麺類'
        ],
        title: 'カテゴリ種別1'
      },
      {
        productNames: [
          '食用油1',
          'スープ2',
          '麺類3'
        ],
        title: 'カテゴリ種別2'
      }
    ],
    selectItem: {

    }
  }),
  computed: {
    ...mapState('analyzeresult', {
      analyzeTargetCode: state => state.historyData.analyze_target_code,
      conditions: state => state.historyData.conditions,
      condition_jp: state => state.historyData.condition_jp,
      history_id: state => state.historyData.id,
      history_publish_setting: state => state.historyData.publish_setting
    }),
    analyze_target_code () {
      if (this.selectItem && this.selectItem.conditions) {
        return this.selectItem.conditions.type
      }
      return null
    },
    historyPublishSetting () {
      if (this.showAddBookmark) {
        return this.history_publish_setting
      } else if (this.showEditBookmark) {
        return this.editData.historyPublishSetting
      }
    }
  },
  created () {
    console.log('BookmarkDialog created!')
  },
  watch: {
    showSelectBookmark (v) {
      this.selectItem = {}
    }
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    },
    onUpdateBookmark () {
      this.$emit('onUpdateBookmark', this.editData)
    },
    onRegisteBookmark () {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          let params = this.editData
          params.history_id = this.history_id
          this.$store.dispatch('pagebookmarklist/doAdd', params)
          this.$emit('onRegisteBookmark', params)
        }
      })
    },
    onSelectChanged (item) {
      this.selectItem = item
    },
    onApplyBookmark () {
      console.log('onApplyBookmark' + this.selectItem.history_id)
      if (!_.isEmpty(this.selectItem) && this.selectItem.history_id) {
        let path = '/analyze/'.concat(this.$route.params.code)
        let routeTarget = {
          path: path,
          query: {
            history_id: this.selectItem.history_id
          }
        }
        this.$router.push(routeTarget)
        this.onClose()
      }
    }
  }
}
